import * as Sentry from '@sentry/react';

const _getDsnPath = () => {
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_SENTRY_DSN;
  }

  return null;
};

export const init = () => {
  const dsnPath = _getDsnPath();

  Sentry.init({
    ignoreErrors: [
      'The operation is insecure.', // https://github.com/apollographql/subscriptions-transport-ws/issues/332
      'Non-Error promise rejection captured',
      /Network Error/,
      'timeout exceeded',
      'Request aborted',
      'ResizeObserver loop completed with undelivered notifications.', // Nothing to worry about here (https://github.com/juggle/resize-observer/issues/103)
      /__gCrWeb\.instantSearch\.clearHighlight/,
      /__gCrWeb\.instantSearch\.setIOSParameters/
    ],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    dsn: dsnPath
  });
};

export default {
  init
};
